import {AppState} from '../../store';
import {
  dollarFormatter,
  percentageFormatter,
} from '../../../utils/numberFormatter';

export const getExchangesData = (state: AppState) => state.exchanges.data;

export const getExchangesLoading = (state: AppState) =>
  state.exchanges.isLoading;

export const getSelectExchanges = (state: AppState) =>
  state.exchanges.data.map(({name, slug}) => ({name, slug}));

export const getDashboardExchanges = (
  state: AppState,
): [
  {value: string; image: string},
  {value: string; customClasses: string},
  {value: string},
  {value: string},
][] =>
  state.exchanges.data.map(
    ({name, image, price, dailyVolume, priceChangePercent}) => [
      {value: name, image},
      {value: dollarFormatter(price, 2), customClasses: 'bold'},
      {value: dollarFormatter(dailyVolume, 0)},
      {value: percentageFormatter(priceChangePercent)},
    ],
  );

export const getTokenExchanges = (
  state: AppState,
): {
  name: string;
  slug: string;
  image: string;
  price: string;
  orders: number;
}[] =>
  state.exchanges.data.map(({name, image, price, slug}) => ({
    name,
    image,
    slug,
    price: dollarFormatter(price, 2),
    orders: 0,
  }));
